/**
 * Liberty Tires -- Theme JavaScript
 *
 * Consolidated from concept pages:
 *   homepage, collection, product, parts, services, fleet, cart
 *
 * Vanilla JS only. No jQuery.
 * Uses event delegation where possible.
 * Shopify Cart API integration via fetch.
 */

/* ==========================================================
   THEME TOGGLE  --  runs IMMEDIATELY to prevent FOUC
   ========================================================== */
(function() {
  'use strict';
  var saved = localStorage.getItem('lt-theme') || 'light';
  document.documentElement.setAttribute('data-theme', saved);
})();


/* ==========================================================
   MAIN IIFE  --  everything else waits for DOMContentLoaded
   ========================================================== */
(function() {
  'use strict';

  /* --------------------------------------------------------
     HELPERS
     -------------------------------------------------------- */
  function $(selector, scope) {
    return (scope || document).querySelector(selector);
  }
  function $$(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }
  function on(el, event, handler) {
    if (el) el.addEventListener(event, handler);
  }
  function delegate(parent, selector, event, handler) {
    on(parent, event, function(e) {
      var target = e.target.closest(selector);
      if (target && parent.contains(target)) {
        handler.call(target, e);
      }
    });
  }
  function lockScroll() {
    document.body.style.overflow = 'hidden';
  }
  function unlockScroll() {
    document.body.style.overflow = '';
  }
  function formatMoney(cents) {
    return '$' + (cents / 100).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  /* --------------------------------------------------------
     1. THEME TOGGLE
     Persists to localStorage, swaps data-theme attribute.
     The initial application already ran above (before DOM ready).
     Here we just wire up the click handler and icon swap.
     -------------------------------------------------------- */
  var ThemeToggle = {
    init: function() {
      var btns = $$('.theme-toggle');
      if (!btns || !btns.length) return;
      var self = this;
      for (var i = 0; i < btns.length; i++) self._updateIcon(btns[i]);
      for (var k = 0; k < btns.length; k++) {
        on(btns[k], 'click', function() {
          var current = document.documentElement.getAttribute('data-theme');
          var next = current === 'dark' ? 'light' : 'dark';
          document.documentElement.setAttribute('data-theme', next);
          localStorage.setItem('lt-theme', next);
          for (var j = 0; j < btns.length; j++) self._updateIcon(btns[j]);
        });
      }
    },

    _updateIcon: function(btn) {
      var theme = document.documentElement.getAttribute('data-theme');
      var moon = btn.querySelector('.icon-moon');
      var sun  = btn.querySelector('.icon-sun');
      if (moon) moon.style.display = theme === 'dark' ? 'inline' : 'none';
      if (sun)  sun.style.display  = theme === 'light' ? 'inline' : 'none';
    }
  };

  /* --------------------------------------------------------
     2. MOBILE MENU
     Open/close overlay, body scroll lock.
     Search toggle also opens menu and focuses input.
     -------------------------------------------------------- */
  var MobileMenu = {
    init: function() {
      var overlay  = $('#mobileMenuOverlay');
      var menuBtn  = $('.mobile-menu-btn');
      var closeBtn = $('#mobileMenuClose');
      var searchBtn = $('#searchToggle');

      if (!overlay) return;

      function openMenu() {
        overlay.classList.add('active');
        lockScroll();
      }
      function closeMenu() {
        overlay.classList.remove('active');
        unlockScroll();
      }

      on(menuBtn, 'click', openMenu);
      on(closeBtn, 'click', closeMenu);
      on(overlay, 'click', function(e) {
        if (e.target === overlay) closeMenu();
      });

      // Search button opens mobile menu and focuses the search input
      on(searchBtn, 'click', function() {
        openMenu();
        setTimeout(function() {
          var input = $('.mobile-search-input');
          if (input) input.focus();
        }, 350);
      });

      // Close menu when clicking nav links (not toggle buttons)
      $$('.mobile-menu-nav a').forEach(function(link) {
        on(link, 'click', closeMenu);
      });

      // Escape key closes menu
      on(document, 'keydown', function(e) {
        if (e.key === 'Escape' && overlay.classList.contains('active')) {
          closeMenu();
        }
      });
    }
  };

  /* --------------------------------------------------------
     3. MOBILE ACCORDION NAVIGATION
     Toggle .open class on .mobile-nav-group parents.
     Uses event delegation on the menu overlay.
     -------------------------------------------------------- */
  var MobileAccordion = {
    init: function() {
      var nav = $('.mobile-menu-nav');
      if (!nav) return;

      delegate(nav, '.mobile-nav-toggle', 'click', function(e) {
        e.preventDefault();
        var group = this.closest('.mobile-nav-group');
        if (!group) return;

        // Close other open groups (accordion behavior)
        $$('.mobile-nav-group.open', nav).forEach(function(g) {
          if (g !== group) g.classList.remove('open');
        });

        group.classList.toggle('open');
      });
    }
  };

  /* --------------------------------------------------------
     4. STICKY HEADER
     Adds .scrolled class to the site header when the user
     scrolls past a threshold.
     -------------------------------------------------------- */
  var StickyHeader = {
    threshold: 50,

    init: function() {
      var header = $('header') || $('.header');
      var trustBar = $('.trust-bar');
      if (!header) return;

      var self = this;
      var ticking = false;

      window.addEventListener('scroll', function() {
        if (!ticking) {
          window.requestAnimationFrame(function() {
            if (window.scrollY > self.threshold) {
              header.classList.add('scrolled');
              if (trustBar) trustBar.classList.add('hide');
            } else {
              header.classList.remove('scrolled');
              if (trustBar) trustBar.classList.remove('hide');
            }
            ticking = false;
          });
          ticking = true;
        }
      }, { passive: true });
    }
  };

  /* --------------------------------------------------------
     5. CART DRAWER
     Slide-in mini cart. Opens on "Add to Cart" success or
     cart icon click. Closes on overlay / close button / Escape.
     -------------------------------------------------------- */
  var CartDrawer = {
    overlay: null,

    init: function() {
      this.overlay = $('#cartDrawerOverlay');
      if (!this.overlay) return;

      var self = this;
      var toggleBtn = $('#cartDrawerToggle');

      on(toggleBtn, 'click', function() { self.open(); });
      // Close button lives INSIDE .cart-drawer, whose innerHTML is replaced on every
      // refresh() — so a direct binding dies after the first cart change. Delegate on the
      // overlay (which is never replaced) so the X keeps working, like the qty/remove buttons.
      delegate(this.overlay, '.cart-drawer-close', 'click', function() { self.close(); });
      on(this.overlay, 'click', function(e) {
        if (e.target === self.overlay) self.close();
      });

      // Also open from header cart button(s) with .cart-btn class
      delegate(document, '.cart-btn', 'click', function(e) {
        // Don't hijack links that are meant to go to /cart
        if (this.tagName === 'A' && this.getAttribute('href') === '/cart') return;
        e.preventDefault();
        self.open();
      });

      on(document, 'keydown', function(e) {
        if (e.key === 'Escape' && self.overlay && self.overlay.classList.contains('active')) {
          self.close();
        }
      });

      // Quantity +/- buttons (delegated on the overlay so they survive refresh)
      delegate(this.overlay, '.cart-drawer-qty-btn', 'click', function() {
        if (self._busy) return;
        var itemEl = this.closest('.cart-drawer-item');
        if (!itemEl) return;
        var key = itemEl.getAttribute('data-key');
        var qtyEl = itemEl.querySelector('.cart-drawer-item-qty span');
        var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
        if (isNaN(current)) current = 1;
        var next = this.getAttribute('data-action') === 'increase' ? current + 1 : current - 1;
        if (next < 0) next = 0;
        self._changeLine(key, next);
      });

      // Remove line button
      delegate(this.overlay, '.cart-drawer-item-remove', 'click', function() {
        if (self._busy) return;
        var itemEl = this.closest('.cart-drawer-item');
        if (itemEl) self._changeLine(itemEl.getAttribute('data-key'), 0);
      });
    },

    _busy: false,

    /** Change a drawer line to a new quantity (0 removes), then refresh. */
    _changeLine: function(key, quantity) {
      if (!key) return;
      var self = this;
      self._busy = true;
      ShopifyCart.changeItem(key, quantity)
        .then(function() { return self.refresh(); })
        .catch(function(err) { console.error('[LT] Cart drawer change failed:', err); })
        .then(function() { self._busy = false; });
    },

    open: function() {
      if (this.overlay) {
        this.overlay.classList.add('active');
        lockScroll();
      }
    },

    close: function() {
      if (this.overlay) {
        this.overlay.classList.remove('active');
        unlockScroll();
      }
    },

    /** Refresh drawer contents after cart change via Section Rendering API */
    refresh: function() {
      var self = this;
      return fetch('/?sections=cart-drawer', {
        credentials: 'same-origin'
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data['cart-drawer']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = data['cart-drawer'];
          var newDrawer = tmp.querySelector('.cart-drawer');
          var currentDrawer = self.overlay ? self.overlay.querySelector('.cart-drawer') : null;
          if (newDrawer && currentDrawer) {
            currentDrawer.innerHTML = newDrawer.innerHTML;
          }
        }
      })
      .catch(function(err) {
        console.error('[LT] Cart drawer refresh failed:', err);
      });
    }
  };

  /* --------------------------------------------------------
     6. FLEET QUOTE MODAL
     Open/close with overlay. Used on homepage, collection,
     product, parts, services, fleet pages.
     -------------------------------------------------------- */
  var FleetQuoteModal = {
    overlay: null,

    init: function() {
      this.overlay = $('#fqModalOverlay');
      if (!this.overlay) return;

      var self = this;
      var closeBtn = $('#fqModalClose');

      on(closeBtn, 'click', function() { self.close(); });
      on(this.overlay, 'click', function(e) {
        if (e.target === self.overlay) self.close();
      });
      on(document, 'keydown', function(e) {
        if (e.key === 'Escape' && self.overlay.classList.contains('active')) {
          self.close();
        }
      });

      // Bind any element whose text contains "Fleet Quote"
      delegate(document, 'a, button', 'click', function(e) {
        if (this.textContent.indexOf('Fleet Quote') !== -1 && !this.closest('.fq-modal') && !this.closest('.fq-modal-overlay')) {
          // If there's an inline fleet form on this page, let anchor links scroll to it
          var href = this.getAttribute('href');
          if (href === '#fleet-quote' && document.getElementById('fleet-quote')) {
            return;
          }
          e.preventDefault();
          self.open();
        }
      });

      // Size checkbox toggles inside modal
      delegate(document, '.fq-size-check', 'click', function() {
        var input = this.querySelector('input[type="checkbox"]');
        if (input) input.checked = !input.checked;
        this.classList.toggle('active', input ? input.checked : !this.classList.contains('active'));
        var icon = this.querySelector('.fq-check-icon');
        if (icon) {
          icon.textContent = this.classList.contains('active') ? '\u2713' : '';
        }
      });

      // Modal form submit (global fleet-quote-modal)
      var fqForm = $('#fleet-quote-form');
      if (fqForm) {
        on(fqForm, 'submit', function(e) {
          e.preventDefault();
          var btn = fqForm.querySelector('.fq-submit-btn');
          if (!btn) return;
          var originalText = btn.textContent;
          btn.textContent = 'Sending\u2026';
          btn.disabled = true;

          fetch('/contact', {
            method: 'POST',
            body: new FormData(fqForm),
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          }).then(function() {
            btn.textContent = '\u2713 Quote Sent! We\u2019ll respond within 2 business hours.';
            btn.style.background = '#22c55e';
            btn.style.color = '#000';
            fqForm.reset();
            setTimeout(function() {
              self.close();
              btn.textContent = originalText;
              btn.style.background = '';
              btn.style.color = '';
              btn.disabled = false;
            }, 3000);
          }).catch(function() {
            btn.textContent = 'Error \u2014 please try again';
            btn.style.background = '#ef4444';
            btn.style.color = '#fff';
            btn.disabled = false;
            setTimeout(function() {
              btn.textContent = originalText;
              btn.style.background = '';
              btn.style.color = '';
            }, 3000);
          });
        });
      }

      // Inline fleet form (fleet.html)
      var inlineForm = $('#fleetInlineForm');
      if (inlineForm) {
        on(inlineForm, 'submit', function(e) {
          e.preventDefault();
          if (!FormValidation.validate(inlineForm)) return;

          var btn = $('#inlineSubmitBtn');
          if (!btn) return;
          var originalText = btn.textContent;
          btn.textContent = '\u2713 Quote Request Sent!';
          btn.style.background = '#22c55e';
          btn.style.color = '#fff';
          setTimeout(function() {
            btn.textContent = originalText;
            btn.style.background = '';
            btn.style.color = '';
          }, 3000);
        });
      }
    },

    open: function() {
      if (this.overlay) {
        this.overlay.classList.add('active');
        lockScroll();
      }
    },

    close: function() {
      if (this.overlay) {
        this.overlay.classList.remove('active');
        unlockScroll();
      }
    }
  };

  /* --------------------------------------------------------
     7. QUANTITY SELECTOR
     +/- buttons, preset qty buttons, update price display.
     Covers product cards (homepage/collection) and PDP.
     -------------------------------------------------------- */
  var QuantitySelector = {
    init: function() {
      this._initCardPresets();
      // _initProductPage() removed: it was inert (targeted a non-existent #qtyInput
      // and early-returned). The live PDP qty/price UI is driven by the inline
      // script in sections/product-page.liquid keyed to #productQty. Keeping the
      // dead call risked a future half-fix creating a second competing handler.
      this._initCartPage();
    },

    /* --- Collection / Homepage product card qty presets --- */
    _initCardPresets: function() {
      /* Card presets removed — tier pricing table replaces qty presets */
    },

    /* PDP quantity UI lives in the inline script of sections/product-page.liquid (keyed to #productQty); the old
       inert PDP helpers here, with made-up fallback prices, were removed 23.10.2026. */

    /* --- Cart page quantity controls --- */
    _initCartPage: function() {
      var cartLayout = $('.cart-layout');
      if (!cartLayout) return;

      var self = this;

      // Initial render: totals from the server cart (after automatic discounts), then the qty-aware tier banner
      this._refreshServerTotals();

      // +/- buttons on cart items
      delegate(cartLayout, '.qty-btn', 'click', function() {
        var input = this.parentElement.querySelector('.qty-input');
        if (!input) return;

        var currentVal = parseInt(input.value, 10) || 1;

        if (this.classList.contains('qty-minus')) {
          if (currentVal > 1) input.value = currentVal - 1;
        } else if (this.classList.contains('qty-plus')) {
          if (currentVal < 99) input.value = currentVal + 1;
        }

        self._serverFresh = false;
        self._updateCartTotals();
        self._syncLineToServer(input);
      });

      // Manual qty input change on cart items
      delegate(cartLayout, '.qty-input', 'change', function() {
        var val = parseInt(this.value, 10);
        if (isNaN(val) || val < 1) this.value = 1;
        if (val > 99) this.value = 99;
        self._serverFresh = false;
        self._updateCartTotals();
        self._syncLineToServer(this);
      });

      // Remove item
      delegate(cartLayout, '.remove-btn', 'click', function(e) {
        e.preventDefault();
        var item = this.closest('.cart-item');
        if (!item) return;

        // Remove from Shopify cart via API
        var key = item.getAttribute('data-item-key');
        if (key) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          }).then(function(res) { return res.ok ? res.json() : Promise.reject(res.status); })
            .then(function(cart) { self._applyServerTotals(cart); })
            .catch(function(err) { console.error('[LT] Cart remove failed:', err); self._refreshServerTotals(); });
        }

        item.style.transition = 'all 0.3s ease';
        item.style.opacity = '0';
        item.style.transform = 'translateX(-20px)';

        setTimeout(function() {
          item.remove();
          self._updateCartTotals();

          // Show empty state if no items left
          if ($$('.cart-item').length === 0) {
            var layout = $('.cart-layout');
            if (layout) {
              layout.innerHTML =
                '<div class="empty-cart" style="grid-column:1/-1;">' +
                  '<div class="empty-cart-icon">&#128722;</div>' +
                  '<h2>Your cart is empty</h2>' +
                  '<p>Browse our selection of commercial truck tires, parts, and accessories.</p>' +
                  '<a href="/" class="btn btn-primary">Shop Tires</a>' +
                  '<br><br>' +
                  '<a href="tel:2246428165" class="empty-cart-phone">&#9742; Call (224) 642-8165 for fleet orders</a>' +
                '</div>';
            }
          }
        }, 300);
      });

      // Discount code
      var discountBtn = $('#discountApply');
      if (discountBtn) {
        on(discountBtn, 'click', function() {
          var input = $('#discountInput');
          if (!input) return;
          var code = input.value.trim().toUpperCase();

          if (code === '') {
            input.style.borderColor = 'var(--error)';
            setTimeout(function() { input.style.borderColor = ''; }, 1500);
            return;
          }

          // In Shopify, discount codes are applied via /discount/<code>
          // For now, visual feedback only
          var btn = discountBtn;
          btn.textContent = 'Applying...';
          btn.disabled = true;

          ShopifyCart.applyDiscount(code).then(function(success) {
            if (success) {
              btn.textContent = 'Applied!';
              btn.style.background = 'var(--success)';
              btn.style.borderColor = 'var(--success)';
              btn.style.color = '#fff';
              input.disabled = true;
              input.style.opacity = '0.6';
            } else {
              btn.textContent = 'Invalid';
              btn.style.background = 'var(--error)';
              btn.style.borderColor = 'var(--error)';
              btn.style.color = '#fff';
              setTimeout(function() {
                btn.textContent = 'Apply';
                btn.style.background = '';
                btn.style.borderColor = '';
                btn.style.color = '';
                btn.disabled = false;
              }, 2000);
            }
          });
        });
      }

      // Cross-sell add buttons
      delegate(document, '.cross-sell-add, .drawer-cross-add', 'click', function() {
        var self = this;
        var variantId = this.dataset.variantId;
        if (variantId) {
          ShopifyCart.addItem(variantId, 1).then(function() {
            self.textContent = 'Added!';
            self.style.borderColor = 'var(--success)';
            self.style.color = 'var(--success)';
            CartDrawer.refresh();
            setTimeout(function() {
              self.textContent = '+ Add';
              self.style.borderColor = '';
              self.style.color = '';
            }, 2000);
          });
        } else {
          // Fallback visual-only feedback
          self.textContent = 'Added!';
          self.style.borderColor = 'var(--success)';
          self.style.color = 'var(--success)';
          setTimeout(function() {
            self.textContent = '+ Add';
            self.style.borderColor = '';
            self.style.color = '';
          }, 2000);
        }
      });
    },

    _formatMoney: function(cents) {
      var dollars = (cents / 100).toFixed(2);
      return '$' + dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    _syncTimers: {},

    /* Push qty change to Shopify cart via /cart/change.js (debounced per line). */
    _syncLineToServer: function(input) {
      var key = input.getAttribute('data-key');
      var qty = parseInt(input.value, 10) || 1;
      if (!key) return;
      var timers = this._syncTimers;
      if (timers[key]) clearTimeout(timers[key]);
      var self = this;
      timers[key] = setTimeout(function() {
        ShopifyCart.changeItem(key, qty).then(function(cart) {
          self._applyServerTotals(cart);
        }).catch(function(err) {
          console.error('[LT] Cart sync failed:', err);
          // Usually a stale line key (it changes when the automatic discount starts or stops): re-read the cart,
          // retry once with the fresh key, and if that fails too show the quantity the server actually has.
          self._refreshServerTotals(function(cart) {
            var newKey = input.getAttribute('data-key');
            var retry = (newKey && newKey !== key) ? ShopifyCart.changeItem(newKey, qty).then(function(c) { self._applyServerTotals(c); }) : Promise.reject(err);
            retry.catch(function() {
              var variantId = (newKey || key).split(':')[0], it = null;
              (cart.items || []).forEach(function(x) { if (String(x.variant_id) === variantId) it = x; });
              if (it && parseInt(input.value, 10) !== it.quantity) { input.value = it.quantity; self._updateCartTotals(); }
            });
          });
        });
      }, 400);
    },

    _serverCart: null,
    _serverFresh: false,

    /* Totals from /cart.js: cart.total_price and item.final_price are after automatic discounts,
       which is what checkout uses for the free-delivery thresholds. */
    _refreshServerTotals: function(cb) {
      var self = this;
      ShopifyCart.getCart().then(function(cart) {
        self._applyServerTotals(cart);
        if (typeof cb === 'function') cb(cart);
      }).catch(function(err) {
        console.error('[LT] Cart fetch failed:', err);
        self._updateCartTotals();
      });
    },

    _applyServerTotals: function(cart) {
      if (cart && cart.items) {
        this._serverCart = cart;
        this._serverFresh = true;
        // Line keys change when an automatic discount starts or stops applying: refresh them in the DOM,
        // otherwise the next +/- or Remove posts a stale key and /cart/change.js answers 400.
        var byVariant = {};
        cart.items.forEach(function(it) { byVariant[String(it.variant_id)] = it; });
        $$('.cart-item').forEach(function(item) {
          var oldKey = item.getAttribute('data-item-key') || '';
          var it = byVariant[oldKey.split(':')[0]];
          if (it && it.key !== oldKey) {
            item.setAttribute('data-item-key', it.key);
            item.querySelectorAll('[data-key]').forEach(function(el) {
              if (el.getAttribute('data-key') === oldKey) el.setAttribute('data-key', it.key);
            });
          }
        });
      }
      this._updateCartTotals();
    },

    _updateCartTotals: function() {
      var items = $$('.cart-item');
      var subtotal = 0;
      var totalItems = 0;
      var fleetSavingsCents = 0;
      var tireTotal = 0;
      var maxTireLine = 0;
      var self = this;
      var serverItems = {};
      var serverByVariant = {};
      if (this._serverCart && this._serverCart.items) {
        this._serverCart.items.forEach(function(it) { serverItems[it.key] = it; serverByVariant[String(it.variant_id)] = it; });
      }

      items.forEach(function(item) {
        var unitPriceCents = parseInt(item.getAttribute('data-unit-price'), 10) || 0;
        var itemKey = item.getAttribute('data-item-key') || '';
        var serverItem = serverItems[itemKey] || serverByVariant[itemKey.split(':')[0]] || null;
        var finalUnitCents = (serverItem && typeof serverItem.final_price === 'number') ? serverItem.final_price : unitPriceCents;
        var qtyInput  = item.querySelector('.qty-input');
        var qty = parseInt(qtyInput ? qtyInput.value : '1', 10) || 1;
        var lineTotalCents = unitPriceCents * qty;
        // Tire lines carry the 8/32 tier thresholds; the automatic 8+ discount applies per line (8 or more of the same tire)
        var t2Min = parseInt(item.getAttribute('data-tier2-min'), 10) || 0;
        var t2Cents = parseInt(item.getAttribute('data-tier2-price'), 10) || unitPriceCents;
        var isTireAttr = item.getAttribute('data-is-tire');
        var isTire = isTireAttr ? isTireAttr === 'true' : t2Min === 8;
        if (isTire) {
          tireTotal += qty;
          if (t2Cents < unitPriceCents && qty > maxTireLine) maxTireLine = qty;
        }

        // Line total at list price; when an automatic volume discount applies, the discounted line total below it
        var lineTotals = item.querySelectorAll('.line-total');
        if (lineTotals[0]) lineTotals[0].textContent = self._formatMoney(lineTotalCents);
        var finalEl = lineTotals[1] || null;
        if (!self._serverFresh) {
          // Quantity just changed: the discounted line total is only known once /cart/change.js answers, keep the last one
        } else if (serverItem && serverItem.final_line_price < serverItem.original_line_price) {
          if (!finalEl && lineTotals[0]) {
            finalEl = document.createElement('div');
            finalEl.className = 'line-total';
            finalEl.style.color = 'var(--success)';
            lineTotals[0].parentNode.appendChild(finalEl);
          }
          if (finalEl) finalEl.textContent = self._formatMoney(serverItem.final_line_price);
        } else if (finalEl) {
          finalEl.remove();
        }

        // Update unit price display
        var unitPriceEl = item.querySelector('.unit-price');
        if (unitPriceEl) unitPriceEl.textContent = self._formatMoney(unitPriceCents) + (isTire ? '/tire' : '/ea');

        subtotal += finalUnitCents * qty;
        totalItems += qty;
      });

      // Summary
      var subtotalEl = $('#summarySubtotal');
      var totalEl    = $('#summaryTotal');
      // Order totals only from the server cart (after automatic discounts): until /cart/change.js answers, keep the last confirmed numbers
      if (this._serverFresh) {
        var sc = this._serverCart;
        if (sc && sc.items && sc.items.length === items.length && typeof sc.items_subtotal_price === 'number') subtotal = sc.items_subtotal_price;
        if (subtotalEl) subtotalEl.textContent = this._formatMoney(subtotal);
        if (totalEl)    totalEl.textContent = this._formatMoney(subtotal);
      }

      // Cart header count
      var cartHeader = $('.cart-header h1 .count');
      if (cartHeader) {
        cartHeader.textContent = '(' + totalItems + ' item' + (totalItems !== 1 ? 's' : '') + ')';
      }

      // Subtotal label
      var subtotalLabel = $('.summary-row .label');
      if (subtotalLabel && subtotalLabel.textContent.indexOf('Subtotal') !== -1) {
        subtotalLabel.textContent = 'Subtotal (' + totalItems + ' item' + (totalItems !== 1 ? 's' : '') + ')';
      }

      // Header cart badge
      var headerCount = $('.cart-count');
      if (headerCount) headerCount.textContent = totalItems;

      // Free local delivery banner (cents: $500 within 35 mi, $1,500 within 80 mi, $1,800 within 100 mi)
      var banner = $('.free-delivery-banner');
      // Rewrite the delivery banner only from server-confirmed totals (after automatic discounts); until then keep the Liquid render
      if (banner && this._serverFresh) {
        var bannerMsg;
        if (subtotal >= 180000) {
          bannerMsg = 'Your order qualifies for FREE local delivery within 100 miles of Bartlett, IL (orders $1,800+).';
        } else if (subtotal >= 150000) {
          bannerMsg = 'FREE local delivery within 80 miles of Bartlett, IL. Spend ' + this._formatMoney(180000 - subtotal) + ' more for free delivery within 100 miles.';
        } else if (subtotal >= 50000) {
          bannerMsg = 'FREE local delivery within 35 miles of Bartlett, IL. Spend ' + this._formatMoney(150000 - subtotal) + ' more for free delivery within 80 miles.';
        } else {
          bannerMsg = 'Spend ' + this._formatMoney(50000 - subtotal) + ' more for FREE local delivery within 35 miles of Bartlett, IL. Warehouse pickup is always free.';
        }
        var bannerText = banner.querySelector('span:not(.icon)');
        if (bannerText) bannerText.textContent = bannerMsg;
        // Match the Liquid render: muted style below the first threshold, accent style once delivery is free somewhere
        banner.style.background = subtotal >= 50000 ? '' : 'rgba(255,255,255,0.05)';
        banner.style.borderColor = subtotal >= 50000 ? '' : 'var(--border)';
        banner.style.display = subtotal > 0 ? 'flex' : 'none';
      }

      // Render tier banner (qty-aware, replaces stale Liquid render)
      this._renderTierBanner(tireTotal, maxTireLine);
    },

    /* Render the qty-aware fleet-tier banner (replaces stale server-rendered version). */
    _renderTierBanner: function(tireTotal, maxTireLine) {
      var el = $('#tierBanner');
      if (!el) return;
      var html = '';
      var quoteBtn = '<a href="/pages/fleet#fleet-quote" class="btn btn-primary" style="width: 100%; justify-content: center; font-size: 14px; padding: 10px;">Request a Fleet Quote &#8594;</a>';
      if (tireTotal >= 32) {
        html =
          '<div class="tier-savings-banner" style="background: rgba(245,197,24,0.08); border: 1px solid rgba(245,197,24,0.2); border-radius: var(--radius); padding: 16px; margin-bottom: 16px;">' +
            '<p style="font-size: 14px; color: var(--accent); font-weight: 700; margin: 0 0 8px;">&#127942; 32+ tires &mdash; call us for a custom quote</p>' +
            '<p style="font-size: 13px; color: var(--text-secondary); margin: 0 0 12px;">The 8+ price is applied automatically at checkout for 8 or more of the same tire. For ' + tireTotal + ' tires we prepare a custom per-tire quote &mdash; call (224) 642-8165 or send the form.</p>' +
            quoteBtn +
          '</div>';
      } else if (maxTireLine >= 8) {
        html =
          '<div class="tier-savings-banner" style="background: rgba(245,197,24,0.08); border: 1px solid rgba(245,197,24,0.2); border-radius: var(--radius); padding: 16px; margin-bottom: 16px;">' +
            '<p style="font-size: 14px; color: var(--accent); font-weight: 700; margin: 0 0 8px;">&#128666; Fleet Tier (8+) &mdash; volume pricing applies</p>' +
            '<p style="font-size: 13px; color: var(--text-secondary); margin: 0 0 12px;">The 8+ price shown on each tire page is applied automatically at checkout for 8 or more of the same tire. Need a custom quote? Use the form.</p>' +
            quoteBtn +
          '</div>';
      } else if (maxTireLine >= 4) {
        html =
          '<div style="background: rgba(255,255,255,0.05); border: 1px solid var(--border); border-radius: var(--radius); padding: 12px 16px; margin-bottom: 16px;">' +
            '<p style="font-size: 13px; color: var(--text-secondary); margin: 0;">Add ' + (8 - maxTireLine) + ' more of the same tire for <a href="/pages/fleet" style="color: var(--accent); font-weight: 700; text-decoration: none;">volume pricing</a> (the 8+ price applies automatically at checkout).</p>' +
          '</div>';
      }
      el.innerHTML = html;
    }
  };

  /* --------------------------------------------------------
     8. FAQ ACCORDION
     Toggle items. Close others when opening one (single-open).
     Replaces inline onclick handlers from concept HTML.
     -------------------------------------------------------- */
  var FaqAccordion = {
    init: function() {
      delegate(document, '.faq-question', 'click', function(e) {
        e.preventDefault();
        var item = this.closest('.faq-item');
        if (!item) return;

        var list = item.parentElement;
        var isOpen = item.classList.contains('active');

        // Close all siblings
        if (list) {
          $$('.faq-item.active', list).forEach(function(openItem) {
            if (openItem !== item) {
              openItem.classList.remove('active');
              var sibBtn = openItem.querySelector('.faq-question');
              if (sibBtn) sibBtn.setAttribute('aria-expanded', 'false');
            }
          });
        }

        // Toggle the clicked item
        item.classList.toggle('active', !isOpen);
        this.setAttribute('aria-expanded', String(!isOpen));
      });
    }
  };

  /* --------------------------------------------------------
     9. FORM VALIDATION
     Basic client-side validation for services/fleet forms.
     Checks required fields, email format, phone format.
     -------------------------------------------------------- */
  var FormValidation = {
    init: function() {
      // The services request form was removed with the Services page (23.10.2026)

      // Clear error styling on input focus
      delegate(document, '.fq-input, .form-input, input, textarea, select', 'focus', function() {
        this.classList.remove('input-error');
        var errorMsg = this.parentElement ? this.parentElement.querySelector('.field-error') : null;
        if (errorMsg) errorMsg.remove();
      });
    },

    /**
     * Validate all required fields within a form.
     * Returns true if valid, false otherwise.
     */
    validate: function(form) {
      var isValid = true;

      // Clear previous errors
      $$('.input-error', form).forEach(function(el) { el.classList.remove('input-error'); });
      $$('.field-error', form).forEach(function(el) { el.remove(); });

      // Check required fields
      $$('[required]', form).forEach(function(field) {
        if (!field.value || !field.value.trim()) {
          isValid = false;
          FormValidation._showError(field, 'This field is required');
        }
      });

      // Email format
      $$('input[type="email"]', form).forEach(function(field) {
        if (field.value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.value.trim())) {
          isValid = false;
          FormValidation._showError(field, 'Please enter a valid email address');
        }
      });

      // Phone format (loose: at least 10 digits)
      $$('input[type="tel"]', form).forEach(function(field) {
        if (field.value) {
          var digits = field.value.replace(/\D/g, '');
          if (digits.length < 10) {
            isValid = false;
            FormValidation._showError(field, 'Please enter a valid phone number');
          }
        }
      });

      return isValid;
    },

    _showError: function(field, message) {
      field.classList.add('input-error');
      var errorEl = document.createElement('span');
      errorEl.className = 'field-error';
      errorEl.textContent = message;
      errorEl.style.cssText = 'color:var(--error,#ef4444);font-size:12px;margin-top:4px;display:block;';
      if (field.parentElement) field.parentElement.appendChild(errorEl);
    }
  };

  /* --------------------------------------------------------
     10. SMOOTH SCROLL
     For anchor links (href="#section").
     -------------------------------------------------------- */
  var SmoothScroll = {
    init: function() {
      delegate(document, 'a[href^="#"]', 'click', function(e) {
        var targetId = this.getAttribute('href');
        if (!targetId || targetId === '#' || targetId.length <= 1) return;

        var target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          var headerOffset = 80; // account for sticky header height
          var elementPosition = target.getBoundingClientRect().top;
          var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      });
    }
  };

  /* --------------------------------------------------------
     COLLECTION / PARTS: MOBILE FILTER PANEL
     Open/close the slide-out filter drawer.
     -------------------------------------------------------- */
  var FilterPanel = {
    init: function() {
      var overlay     = $('#filterOverlay');
      var panel       = $('#filterPanelMobile');
      var openBtn     = $('#mobileFilterBtn');
      var closeBtn    = $('#filterCloseBtn');
      var applyBtn    = $('#filterApplyMobile');

      if (!overlay || !panel) return;

      function openFilters() {
        overlay.classList.add('active');
        panel.classList.add('active');
        lockScroll();
      }
      function closeFilters() {
        overlay.classList.remove('active');
        panel.classList.remove('active');
        unlockScroll();
      }

      on(openBtn,  'click', openFilters);
      on(overlay,  'click', closeFilters);
      on(closeBtn, 'click', closeFilters);
      if (applyBtn) on(applyBtn, 'click', closeFilters);

      // Close mobile panel when a filter link is clicked (navigation will follow)
      var closeBtn2 = $('#filterCloseBtn2');
      if (closeBtn2) on(closeBtn2, 'click', closeFilters);
    }
  };

  /* --------------------------------------------------------
     PRODUCT PAGE: TABS & GALLERY
     -------------------------------------------------------- */
  var ProductPage = {
    init: function() {
      this._initTabs();
      this._initGallery();
      this._initLibertyScoreModal();
      this._initAddToCart();
    },

    _initTabs: function() {
      delegate(document, '.tab-btn', 'click', function() {
        var tabId = this.dataset.tab;
        if (!tabId) return;

        // Deactivate all
        $$('.tab-btn').forEach(function(b) { b.classList.remove('active'); });
        $$('.tab-content').forEach(function(c) { c.classList.remove('active'); });

        // Activate selected
        this.classList.add('active');
        var tabContent = $('#tab-' + tabId);
        if (tabContent) tabContent.classList.add('active');
      });
    },

    _initGallery: function() {
      delegate(document, '.gallery-thumb', 'click', function() {
        $$('.gallery-thumb').forEach(function(t) { t.classList.remove('active'); });
        this.classList.add('active');

        // Optionally swap main image
        var mainImg = $('.gallery-main img, .gallery-main');
        var imgSrc = this.querySelector('img') ? this.querySelector('img').src : this.dataset.src;
        if (mainImg && imgSrc) {
          if (mainImg.tagName === 'IMG') {
            mainImg.src = imgSrc;
          } else {
            var img = mainImg.querySelector('img');
            if (img) img.src = imgSrc;
          }
        }
      });
    },

    _initLibertyScoreModal: function() {
      var lsOverlay = $('#lsModalOverlay');
      if (!lsOverlay) return;

      var infoBtn  = $('.ls-info-btn');
      var closeBtn = $('#lsModalClose');

      function openModal() {
        lsOverlay.classList.add('active');
        lockScroll();
      }
      function closeModal() {
        lsOverlay.classList.remove('active');
        unlockScroll();
      }

      on(infoBtn,  'click', openModal);
      on(closeBtn, 'click', closeModal);
      on(lsOverlay, 'click', function(e) {
        if (e.target === lsOverlay) closeModal();
      });
      on(document, 'keydown', function(e) {
        if (e.key === 'Escape' && lsOverlay.classList.contains('active')) {
          closeModal();
        }
      });
    },

    _initAddToCart: function() {
      delegate(document, '.btn-atc, .mobile-atc-btn', 'click', function(e) {
        e.preventDefault();

        // Bulk-quote mode: above the threshold set on the product section we don't sell
        // online — the button collects a price request instead. The product page toggles
        // data-bulk-mode on this button as the quantity changes.
        if (this.hasAttribute('data-bulk-mode')) {
          window.location.href = this.getAttribute('data-bulk-href') || '/pages/fleet#fleet-quote';
          return;
        }

        // The mobile ATC bar lives OUTSIDE the product <form>, so closest('form')
        // is null for it — fall back to the product form by id (#product-form).
        var form = this.closest('form') || document.querySelector('.product-form') || document.getElementById('product-form');
        var variantId = form ? (form.querySelector('[name="id"]') || {}).value : null;
        // Read the real quantity field on the form (id="productQty" name="quantity").
        // Previously read a non-existent #qtyInput -> quantity silently fell back to 1.
        var qtyEl = form ? form.querySelector('[name="quantity"]') : null;
        var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;

        if (!variantId) {
          // If no variant id set (concept mode), just open the cart drawer
          CartDrawer.open();
          return;
        }

        var btn = this;
        var originalHTML = btn.innerHTML;
        btn.innerHTML = 'Adding...';
        btn.disabled = true;
        var errBox = document.querySelector('[data-atc-error]');
        if (errBox) { errBox.hidden = true; errBox.textContent = ''; }

        ShopifyCart.addItem(variantId, parseInt(qty, 10)).then(function() {
          btn.innerHTML = '&#10003; Added!';
          // 2026-10-31 (T5): open the drawer only after its content is refreshed, otherwise it
          // shows "Your cart is empty" for a second right after "Added!".
          CartDrawer.refresh().then(function() { CartDrawer.open(); });
          setTimeout(function() {
            btn.innerHTML = originalHTML;
            btn.disabled = false;
          }, 1500);
        }).catch(function(err) {
          // 2026-10-31 (T4): show the cart's own reason (for example, no more stock) under the button
          if (errBox && err && err.userMessage) { errBox.textContent = err.userMessage; errBox.hidden = false; }
          btn.innerHTML = 'Error - Try Again';
          setTimeout(function() {
            btn.innerHTML = originalHTML;
            btn.disabled = false;
          }, 2000);
        });
      });
    }
  };

  /* --------------------------------------------------------
     SHOPIFY CART API HELPERS  (fetch-based)
     -------------------------------------------------------- */
  var ShopifyCart = {

    /**
     * GET the current cart state.
     * @returns {Promise<Object>} cart JSON
     */
    getCart: function() {
      return fetch('/cart.js', {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
      }).then(function(res) { return res.json(); });
    },

    /**
     * Add an item to cart.
     * @param {string|number} variantId  Shopify variant ID
     * @param {number}        quantity   Defaults to 1
     * @param {Object}        [properties]  Optional line item properties
     * @returns {Promise<Object>}
     */
    addItem: function(variantId, quantity, properties) {
      var body = {
        items: [{
          id: parseInt(variantId, 10),
          quantity: quantity || 1
        }]
      };
      if (properties) body.items[0].properties = properties;

      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(function(res) {
        if (!res.ok) {
          // 2026-10-31 (T4): keep the cart's explanation (422 "only N in stock") for the page
          return res.json().catch(function() { return {}; }).then(function(j) {
            var err = new Error('Add to cart failed: ' + res.status);
            err.status = res.status;
            err.userMessage = (j && (j.description || j.message)) || '';
            throw err;
          });
        }
        return res.json();
      }).then(function(data) {
        ShopifyCart._dispatchCartUpdate();
        return data;
      });
    },

    /**
     * Change a line item quantity.
     * @param {string}  line      Line item key
     * @param {number}  quantity  New quantity (0 to remove)
     * @returns {Promise<Object>}
     */
    changeItem: function(line, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: line, quantity: quantity })
      }).then(function(res) {
        if (!res.ok) throw new Error('Cart change failed: ' + res.status);
        return res.json();
      }).then(function(data) {
        ShopifyCart._dispatchCartUpdate();
        return data;
      });
    },

    /**
     * Update cart attributes or note.
     * @param {Object} updates  e.g. { note: '...', attributes: { key: val } }
     * @returns {Promise<Object>}
     */
    updateCart: function(updates) {
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updates)
      }).then(function(res) { return res.json(); });
    },

    /**
     * Clear the entire cart.
     * @returns {Promise<Object>}
     */
    clearCart: function() {
      return fetch('/cart/clear.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
      }).then(function(res) { return res.json(); })
        .then(function(data) {
          ShopifyCart._dispatchCartUpdate();
          return data;
        });
    },

    /**
     * Apply a discount code via redirect.
     * Shopify does not have a direct JS API for discount codes;
     * the standard approach is to navigate to /discount/<code>.
     * For AJAX, we attempt it and return success status.
     * @param {string} code
     * @returns {Promise<boolean>}
     */
    applyDiscount: function(code) {
      return fetch('/discount/' + encodeURIComponent(code), {
        method: 'GET',
        credentials: 'same-origin',
        redirect: 'follow'
      }).then(function(res) {
        return res.ok;
      }).catch(function() {
        return false;
      });
    },

    /**
     * Fetch a rendered section (Shopify Section Rendering API).
     * @param {string} sectionId  e.g. 'cart-drawer', 'header'
     * @returns {Promise<string>}  HTML string
     */
    renderSection: function(sectionId) {
      return fetch('/?sections=' + encodeURIComponent(sectionId), {
        credentials: 'same-origin'
      }).then(function(res) { return res.json(); })
        .then(function(data) { return data[sectionId] || ''; });
    },

    /**
     * Fetch multiple sections at once.
     * @param {string[]} sectionIds
     * @returns {Promise<Object>}
     */
    renderSections: function(sectionIds) {
      return fetch('/?sections=' + sectionIds.map(encodeURIComponent).join(','), {
        credentials: 'same-origin'
      }).then(function(res) { return res.json(); });
    },

    /**
     * Update header cart count badge after cart changes.
     */
    updateCartCount: function() {
      this.getCart().then(function(cart) {
        var badge = $('.cart-count');
        if (badge) badge.textContent = cart.item_count;
      });
    },

    /**
     * Dispatch a custom event so other scripts can react to cart changes.
     */
    _dispatchCartUpdate: function() {
      document.dispatchEvent(new CustomEvent('cart:updated'));
    }
  };

  // Listen for cart updates to refresh the header count
  document.addEventListener('cart:updated', function() {
    ShopifyCart.updateCartCount();
  });

  // Expose ShopifyCart globally for use in Liquid templates
  window.ShopifyCart = ShopifyCart;

  /* --------------------------------------------------------
     COMBOBOX -- searchable dropdown
     Auto-wires any element with [data-combobox] attribute.
     Structure expected:
       .combobox-input (visible text input)
       .combobox-value (hidden input with selected value)
       .combobox-toggle (arrow button)
       .combobox-dropdown > .combobox-option[data-value][data-search]
       .combobox-empty (shown when no options match)
     -------------------------------------------------------- */
  var Combobox = {
    init: function() {
      $$('[data-combobox]').forEach(this._wire);
    },

    _wire: function(root) {
      var input    = root.querySelector('.combobox-input');
      var hidden   = root.querySelector('.combobox-value');
      var toggle   = root.querySelector('.combobox-toggle');
      var dropdown = root.querySelector('.combobox-dropdown');
      var empty    = root.querySelector('.combobox-empty');
      var options  = $$('.combobox-option', root);
      var highlightIdx = -1;

      if (!input || !hidden || !dropdown) return;

      function open()  { root.classList.add('is-open'); input.setAttribute('aria-expanded', 'true'); }
      function close() {
        root.classList.remove('is-open');
        input.setAttribute('aria-expanded', 'false');
        highlightIdx = -1;
        updateHighlight();
      }

      function filter(query) {
        var q = (query || '').toLowerCase().trim();
        var shown = 0;
        options.forEach(function(opt) {
          var match = !q || opt.getAttribute('data-search').indexOf(q) !== -1;
          opt.hidden = !match;
          if (match) shown++;
        });
        if (empty) empty.hidden = shown > 0;
        highlightIdx = -1;
        updateHighlight();
      }

      function updateHighlight() {
        var visible = options.filter(function(o) { return !o.hidden; });
        options.forEach(function(o) { o.classList.remove('is-highlight'); });
        if (highlightIdx >= 0 && visible[highlightIdx]) {
          visible[highlightIdx].classList.add('is-highlight');
          visible[highlightIdx].scrollIntoView({ block: 'nearest' });
        }
      }

      function selectOption(opt) {
        input.value = opt.textContent.trim();
        hidden.value = opt.getAttribute('data-value');
        filter('');
        close();
        root.dispatchEvent(new CustomEvent('combobox:change', {
          bubbles: true,
          detail: { value: hidden.value, label: input.value }
        }));
      }

      on(input, 'focus', function() { open(); filter(input.value); });
      on(input, 'input', function() {
        open();
        filter(input.value);
        hidden.value = '';
      });
      on(input, 'keydown', function(e) {
        var visible = options.filter(function(o) { return !o.hidden; });
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          if (!root.classList.contains('is-open')) open();
          highlightIdx = Math.min(visible.length - 1, highlightIdx + 1);
          updateHighlight();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          highlightIdx = Math.max(0, highlightIdx - 1);
          updateHighlight();
        } else if (e.key === 'Enter') {
          if (visible[highlightIdx]) {
            e.preventDefault();
            selectOption(visible[highlightIdx]);
          }
        } else if (e.key === 'Escape') {
          close();
          input.blur();
        }
      });

      on(toggle, 'click', function() {
        if (root.classList.contains('is-open')) {
          close();
        } else {
          input.focus();
          open();
          filter('');
        }
      });

      on(dropdown, 'mousedown', function(e) {
        var opt = e.target.closest('.combobox-option');
        if (opt && !opt.hidden) {
          e.preventDefault();
          selectOption(opt);
        }
      });

      on(document, 'click', function(e) {
        if (!root.contains(e.target)) close();
      });
    }
  };

  /* --------------------------------------------------------
     TIRE SIZE FILTER -- collection page "Shop by Size"
     Submits the hidden combobox value as a tag filter:
       /collections/{handle}/{size-tag}
     -------------------------------------------------------- */
  var TireSizeFilter = {
    init: function() {
      var form = $('#tireSizeFilterForm');
      if (!form) return;
      var base = form.getAttribute('data-collection-url') || '';
      var hidden = form.querySelector('.combobox-value');

      on(form, 'submit', function(e) {
        e.preventDefault();
        var val = hidden && hidden.value;
        window.location.href = val ? base + '/' + val : base;
      });

      // Also navigate on combobox selection for instant feedback
      on(form, 'combobox:change', function(e) {
        var val = e.detail && e.detail.value;
        if (val) window.location.href = base + '/' + val;
      });
    }
  };

  /* --------------------------------------------------------
     PREDICTIVE SEARCH -- live suggestions (products + more)
     Attaches to every [data-predictive-search] input (header
     bar, mobile menu, homepage hero). Fetches Shopify
     /search/suggest.json with debounce + AbortController, renders
     a [data-predictive-results] dropdown with full keyboard nav.

     Per-input options via data-attributes:
       data-predictive-resources="product,collection,page"  (default "product")
       data-predictive-grouped     -> show group headers + 5/type
       data-predictive-viewall     -> append "Search all results" row
     Optional siblings in the form:
       [data-predictive-progress]  -> loading bar toggled .is-loading
       [data-predictive-status]    -> aria-live region for SR counts
     Suggested-search chips: [data-predictive-chip] buttons inside the
     same .tire-finder block prefill the input and open the dropdown.
     Enter with no active row lets the form submit to /search.
     -------------------------------------------------------- */
  var PredictiveSearch = {
    init: function() {
      $$('[data-predictive-search]').forEach(this._wire);
      this._wireChips();
    },

    _wireChips: function() {
      $$('[data-predictive-chip]').forEach(function(chip) {
        on(chip, 'click', function() {
          var scope = chip.closest('.tire-finder') || document;
          var input = scope.querySelector('[data-predictive-search]');
          if (!input) return;
          var q = (chip.getAttribute('data-q') || chip.textContent || '').trim().replace(/"+$/, '');
          input.value = q;
          input.focus();
          if (typeof input._predictiveTrigger === 'function') input._predictiveTrigger(q);
        });
      });
    },

    _wire: function(input) {
      var form    = input.closest('form');
      var results = form ? form.querySelector('[data-predictive-results]') : null;
      if (!form || !results) return;

      var progress  = form.querySelector('[data-predictive-progress]');
      var status    = form.querySelector('[data-predictive-status]');
      var resources = (input.getAttribute('data-predictive-resources') || 'product').replace(/\s+/g, '');
      var grouped   = input.hasAttribute('data-predictive-grouped');
      var viewall   = input.hasAttribute('data-predictive-viewall');
      var reduce    = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

      var GROUPS = [
        { type: 'product',    key: 'products',    label: 'Products' },
        { type: 'collection', key: 'collections', label: 'Collections' },
        { type: 'page',       key: 'pages',       label: 'Pages' },
        { type: 'article',    key: 'articles',    label: 'Articles' }
      ];
      var ICONS = {
        collection: '<svg viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="2" width="5" height="5" rx="1"/><rect x="9" y="2" width="5" height="5" rx="1"/><rect x="2" y="9" width="5" height="5" rx="1"/><rect x="9" y="9" width="5" height="5" rx="1"/></svg>',
        page: '<svg viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 1.5h5L13 5v9.5H4z"/><path d="M9 1.5V5h4"/></svg>',
        article: '<svg viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M2.5 3.5h11v9h-11z"/><path d="M4.5 6h7M4.5 8.5h7M4.5 11h4"/></svg>'
      };

      var timer = null, controller = null, items = [], activeIdx = -1, optSeq = 0;

      function setProgress(state) { if (progress) progress.classList.toggle('is-loading', !!state); }
      function announce(msg) { if (status) status.textContent = msg; }

      function open() {
        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        if (results.getAttribute('data-open') === 'true') return;
        window.requestAnimationFrame(function() { results.setAttribute('data-open', 'true'); });
      }
      function close() {
        if (results.hidden) return;
        results.setAttribute('data-open', 'false');
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
        activeIdx = -1;
        window.setTimeout(function() {
          if (results.getAttribute('data-open') === 'false') {
            results.hidden = true; results.innerHTML = ''; items = [];
          }
        }, reduce ? 0 : 90);
      }

      function setActive(idx) {
        if (items[activeIdx]) { items[activeIdx].classList.remove('is-active'); items[activeIdx].setAttribute('aria-selected', 'false'); }
        activeIdx = idx;
        results.classList.add('kb');
        if (items[activeIdx]) {
          items[activeIdx].classList.add('is-active');
          items[activeIdx].setAttribute('aria-selected', 'true');
          items[activeIdx].scrollIntoView({ block: 'nearest' });
          input.setAttribute('aria-activedescendant', items[activeIdx].id);
        } else {
          input.removeAttribute('aria-activedescendant');
        }
      }

      function money(val) {
        var n = parseFloat(val);
        if (isNaN(n)) return '';
        return '$' + n.toFixed(2);
      }

      function newOption(extraClass) {
        var a = document.createElement('a');
        a.className = 'predictive-item' + (extraClass ? ' ' + extraClass : '');
        a.setAttribute('role', 'option');
        a.setAttribute('aria-selected', 'false');
        a.id = 'pso-' + (input.id || 'p') + '-' + (optSeq++);
        return a;
      }

      function addProduct(p) {
        var a = newOption('');
        a.href = p.url;
        var img = (p.featured_image && p.featured_image.url) || p.image || '';
        if (img) {
          var im = document.createElement('img');
          im.className = 'predictive-thumb'; im.src = img; im.alt = ''; im.loading = 'lazy';
          a.appendChild(im);
        } else {
          var ph = document.createElement('span'); ph.className = 'predictive-thumb predictive-thumb--ph'; ph.setAttribute('aria-hidden', 'true');
          a.appendChild(ph);
        }
        var body = document.createElement('div'); body.className = 'predictive-body';
        var t = document.createElement('div'); t.className = 'predictive-title'; t.textContent = p.title; body.appendChild(t);
        if (p.type) { var ty = document.createElement('div'); ty.className = 'predictive-type'; ty.textContent = p.type; body.appendChild(ty); }
        a.appendChild(body);
        var priceText = '';
        if (p.price_min != null && p.price_max != null && p.price_min !== p.price_max) priceText = 'From ' + money(p.price_min);
        else if (p.price != null) priceText = money(p.price);
        if (priceText) { var pr = document.createElement('div'); pr.className = 'predictive-price'; pr.textContent = priceText; a.appendChild(pr); }
        a.setAttribute('aria-label', [p.title, p.type, priceText].filter(Boolean).join(', '));
        results.appendChild(a); items.push(a);
      }

      function addSimple(it, type) {
        var a = newOption('predictive-item--simple');
        a.href = it.url;
        var ico = document.createElement('span'); ico.className = 'predictive-ico'; ico.innerHTML = ICONS[type] || ICONS.page;
        a.appendChild(ico);
        var body = document.createElement('div'); body.className = 'predictive-body';
        var t = document.createElement('div'); t.className = 'predictive-title'; t.textContent = it.title; body.appendChild(t);
        a.appendChild(body);
        a.setAttribute('aria-label', it.title + ', ' + type);
        results.appendChild(a); items.push(a);
      }

      function addGroupHeader(label) {
        var h = document.createElement('div'); h.className = 'predictive-group'; h.setAttribute('role', 'presentation'); h.textContent = label;
        results.appendChild(h);
      }

      function addViewAll(q) {
        var a = newOption('predictive-viewall');
        a.href = '/search?q=' + encodeURIComponent(q);
        var label = document.createElement('span'); label.textContent = 'Search all results for "' + q + '"'; a.appendChild(label);
        var arrow = document.createElement('span'); arrow.className = 'predictive-viewall-arrow'; arrow.setAttribute('aria-hidden', 'true'); arrow.textContent = '→'; a.appendChild(arrow);
        a.setAttribute('aria-label', 'Search all results for ' + q);
        results.appendChild(a); items.push(a);
      }

      function render(data, query) {
        results.innerHTML = ''; items = []; activeIdx = -1; optSeq = 0;
        var res = (data && data.resources && data.resources.results) || {};
        var total = 0;
        GROUPS.forEach(function(g) {
          if (resources.indexOf(g.type) === -1) return;
          var arr = res[g.key] || [];
          if (!arr.length) return;
          if (grouped) addGroupHeader(g.label);
          arr.forEach(function(it) {
            total++;
            if (g.type === 'product') addProduct(it); else addSimple(it, g.type);
          });
        });
        if (total === 0) {
          var empty = document.createElement('div'); empty.className = 'predictive-empty'; empty.textContent = 'No matches for "' + query + '"';
          results.appendChild(empty);
          announce('No matches');
        } else {
          announce(total + ' result' + (total === 1 ? '' : 's'));
        }
        if (viewall) addViewAll(query);
        open();
      }

      function renderError(query) {
        results.innerHTML = ''; items = []; activeIdx = -1;
        var er = document.createElement('div'); er.className = 'predictive-empty'; er.textContent = 'Couldn’t load suggestions.';
        results.appendChild(er);
        if (viewall) addViewAll(query);
        announce('Couldn’t load suggestions');
        open();
      }

      function fetchSuggestions(q) {
        if (controller) controller.abort();
        controller = ('AbortController' in window) ? new AbortController() : null;
        setProgress(true);
        var limit = grouped ? 5 : 6;
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
                  '&resources[type]=' + resources +
                  '&resources[limit]=' + limit +
                  '&resources[options][unavailable_products]=last';
        fetch(url, { signal: controller ? controller.signal : undefined, headers: { 'Accept': 'application/json' } })
          .then(function(r) { return r.json(); })
          .then(function(data) { setProgress(false); render(data, q); })
          .catch(function(err) {
            if (err && err.name === 'AbortError') return;
            setProgress(false); renderError(q);
          });
      }

      input._predictiveTrigger = function(q) {
        clearTimeout(timer);
        q = (q || '').trim();
        if (q.length < 2) { close(); return; }
        fetchSuggestions(q);
      };

      on(input, 'input', function() {
        var q = input.value.trim();
        clearTimeout(timer);
        if (q.length < 2) { close(); return; }
        timer = setTimeout(function() { fetchSuggestions(q); }, 250);
      });

      on(input, 'keydown', function(e) {
        if (e.key === 'ArrowDown') {
          if (results.hidden) { if (input.value.trim().length >= 2) input._predictiveTrigger(input.value); return; }
          e.preventDefault(); setActive(Math.min(items.length - 1, activeIdx + 1));
        } else if (e.key === 'ArrowUp') {
          if (results.hidden) return;
          e.preventDefault(); setActive(Math.max(-1, activeIdx - 1));
        } else if (e.key === 'Enter') {
          if (!results.hidden && items[activeIdx]) { e.preventDefault(); window.location.href = items[activeIdx].href; }
        } else if (e.key === 'Escape') {
          if (!results.hidden) { close(); }
          else if (input.value) { input.value = ''; }
        }
      });

      on(results, 'mousemove', function() { results.classList.remove('kb'); });

      on(input, 'focus', function() {
        if (input.value.trim().length >= 2 && items.length) open();
      });

      on(document, 'click', function(e) {
        if (!form.contains(e.target)) close();
      });
    }
  };

  /* --------------------------------------------------------
     INITIALIZE ON DOMContentLoaded
     -------------------------------------------------------- */
  document.addEventListener('DOMContentLoaded', function() {
    ThemeToggle.init();
    MobileMenu.init();
    MobileAccordion.init();
    StickyHeader.init();
    CartDrawer.init();
    FleetQuoteModal.init();
    QuantitySelector.init();
    FaqAccordion.init();
    FormValidation.init();
    SmoothScroll.init();
    FilterPanel.init();
    ProductPage.init();
    Combobox.init();
    TireSizeFilter.init();
    PredictiveSearch.init();

    // Listing-card "Add to Cart" (collection / homepage grids) — global, all pages.
    // Previously .card-add-btn had no handler and, being inside the card's wrapping
    // <a href=product.url>, a click just navigated to the PDP (lost one-click add).
    // Registered here (not in a page-specific init) so it works on every grid.
    delegate(document, '.card-add-btn', 'click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.disabled) return;
      var variantId = this.dataset.variantId;
      if (!variantId) return;
      var self = this;
      var orig = self.innerHTML;
      // Guard against a double-tap firing two /cart/add.js POSTs (would add qty 2
      // for one intended click). Mirrors the PDP button's disabled-in-flight pattern.
      self.disabled = true;
      self.innerHTML = 'Adding…';
      ShopifyCart.addItem(variantId, 1).then(function() {
        self.innerHTML = '✓ Added';
        CartDrawer.refresh().then(function() { CartDrawer.open(); }); // 2026-10-31 (T5): open after refresh
        setTimeout(function() { self.innerHTML = orig; self.disabled = false; }, 1500);
      }).catch(function() {
        self.innerHTML = 'Try again';
        setTimeout(function() { self.innerHTML = orig; self.disabled = false; }, 1500);
      });
    });
  });

})();
/* v2026.06.08 */
